// ABOUTME: Notification component for a relation that moved to another invoice category.
// ABOUTME: Displays with a swap icon in blue, the move itself needs no action.

import { Box, useTheme } from "@mui/material";
import { tokens } from "../../../../theme";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import { useTranslation } from "react-i18next";
import Text from "../../../theme/text/Text";

const InvoiceCategoryChangedNotificationsComp = (props) => {
    const theme = useTheme();
    const {t} = useTranslation();
    const colors = tokens(theme.palette.mode);

    return(
        <Box
            onClick={props.onClick ?? null}
            sx={{
                cursor:"pointer",
                px:1.5,
                display:"flex",
                gap:2,
                width:1,
                py:1.5,
                transition:"200ms",
                borderRadius:4,
                "&:hover" : {
                    background:colors.grey[100],
                    transition:"200ms",
                }
            }}
        >
            <Box
                sx={{
                    height:32,
                    width:32,
                    flexShrink:0,
                    display:'flex',
                    alignItems:"center",
                    justifyContent:'center',
                    background:theme.palette.mode === "dark" ? colors.blue[100] : colors.blue[100],
                    color:theme.palette.mode === "dark" ? colors.blue[400] : colors.blue[400],
                    borderRadius:3,
                }}
            >
                <SwapHorizIcon fontSize="small"/>
            </Box>
            <Box flex={1}>
                <Box
                    sx={{
                        display:"flex",
                        alignItems:"center",
                        gap:1,
                        mb:0.5,
                    }}
                >
                    <Text semibold>{t(props.type)}</Text>
                </Box>
                <Box>
                    <Text>{props.body}</Text>
                </Box>
            </Box>
        </Box>
    )
}

export default InvoiceCategoryChangedNotificationsComp;
